import {qs} from '@shared/helpers/queryString'

import {OrderSheetPageSet, OrderSheetPageSetType} from '@web/core/constants'
import getApi, {createWrapper, getBaseUrl} from '@web/helpers/api'

import {CouponsReloadResponse, ProductDiscountRequest, ProductDiscountResponse} from './interfaces'

const CouponApiUrlInfo = {
    [OrderSheetPageSet.MALL]: {
        /** 상품 할인금액 조회 */
        productDiscount: '/orderSheet/mall/coupons/discount',
        /** 쿠폰페이지 내 > 최대적용 혜택계산기 쿠폰적용 조회 */
        couponsReload: '/orderSheet/mall/coupons/reload',
    },
    [OrderSheetPageSet.EASYBOOKING]: {
        /** 상품 할인금액 조회 */
        productDiscount: '/orderSheet/easyBooking/coupons/discount',
        /** 쿠폰페이지 내 > 최대적용 혜택계산기 쿠폰적용 조회 */
        couponsReload: '/orderSheet/easyBooking/coupons/reload',
    },
    [OrderSheetPageSet.SELLER]: {
        /** 상품 할인금액 조회 */
        productDiscount: '/orderSheet/seller/coupons/discount',
        /** 쿠폰페이지 내 > 최대적용 혜택계산기 쿠폰적용 조회 */
        couponsReload: '/orderSheet/seller/coupons/reload',
    },
    // 패밀리 결제는 쿠폰을 재 선택할 수 없다.
    [OrderSheetPageSet.FAMILY_PAY]: {
        product: '',
        deliveryFee: '',
        productDiscount: '',
    },
}

/** 상품 할인 금액 조회 */
async function getProductCouponDiscount(
    // c1, c2, c3 에 할인금액 재조회 적용시 반영
    pageSet: Extract<OrderSheetPageSetType, 'MALL_CHECKOUT' | 'EASY_BOOK_CHECKOUT' | 'SELLER_CHECKOUT'>,
    params: {orderSheetId: string; discountRequest: ProductDiscountRequest},
) {
    const url = CouponApiUrlInfo[pageSet].productDiscount
    const baseUrl = getBaseUrl(pageSet)
    const api = getApi(baseUrl)
    return createWrapper<ProductDiscountResponse>(api.post(url, params))
}

/** 쿠폰페이지 내 > 최대적용 혜택계산기 쿠폰적용 조회 */
async function getCoupons({
    orderSheetId,
    zipCode,
    address,
    buildingManagementNo,
    pageSet,
}: {
    orderSheetId: string
    zipCode: string
    address?: string
    buildingManagementNo?: string
    pageSet: Extract<OrderSheetPageSetType, 'MALL_CHECKOUT' | 'EASY_BOOK_CHECKOUT' | 'SELLER_CHECKOUT'>
}) {
    const url = CouponApiUrlInfo[pageSet].couponsReload
    const baseUrl = getBaseUrl(pageSet)
    const api = getApi(baseUrl)

    return createWrapper<CouponsReloadResponse>(
        api.get(
            qs.stringifyUrl({
                url,
                query: {
                    orderSheetId,
                    zipCode,
                    ...(address ? {address} : {}),
                    ...(buildingManagementNo ? {buildingManagementNo} : {}),
                },
            }),
        ),
    )
}

export default {
    getProductCouponDiscount,
    getCoupons,
}
